import { createSelector } from "@ngrx/store";

import { AppState } from "../store";
import { OwnerFeatureFlagsState } from "./owner-feature-flags.reducers";

const feature = (state: AppState) => state.ownerFeatureFlags;

export const ownerProductFeatureSummariesSelector = createSelector(
  feature,
  (state: OwnerFeatureFlagsState) => state.summaries
);

export const ownerFeatureFlagsLoadErrorSelector = createSelector(
  feature,
  (state: OwnerFeatureFlagsState) => state.loadError
);

export const ownerFeatureFlagsBulkSavingSelector = createSelector(
  feature,
  (state: OwnerFeatureFlagsState) => state.bulkSaving
);

export const ownerFeatureFlagsBulkSaveErrorSelector = createSelector(
  feature,
  (state: OwnerFeatureFlagsState) => state.bulkSaveError
);
